export default __webpack_public_path__ + "static/media/Chatz3.11fabb7e.png";